import React from 'react';

const ToolComparisonPage = () => {
    return (
        <div className="w-full h-full flex flex-col">
            <div className="flex-grow">
                <iframe 
                    src="/tools/comparison.html" 
                    className="w-full h-full border-none"
                    style={{ minHeight: 'calc(100vh - 120px)' }}
                    title="Billing Excel Comparison"
                />
            </div>
        </div>
    );
};

export default ToolComparisonPage;
